"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPersistLink = exports.PersistLink = void 0;

var _graphql = require("graphql");

var _apolloLink = require("apollo-link");

var _traverse = _interopRequireDefault(require("traverse"));

var _transform = require("./transform");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var toQueryPath = function toQueryPath(path) {
  return path.filter(function (key) {
    return isNaN(Number(key));
  }).join('.');
};
/**
 * Given a data result object, attach __persist values.
 */


var attachPersists = function attachPersists(paths, object) {
  var queryPaths = paths.map(toQueryPath);
  return (0, _traverse["default"])(object).map(function () {
    if (!this.isRoot && this.node && _typeof(this.node) === 'object' && Object.keys(this.node).length && !Array.isArray(this.node)) {
      var path = toQueryPath(this.path);
      this.update(_objectSpread({
        __persist: Boolean(queryPaths.find(function (queryPath) {
          return queryPath.indexOf(path) === 0 || path.indexOf(queryPath) === 0;
        }))
      }, this.node));
    }
  });
};

var PersistLink =
/*#__PURE__*/
function (_ApolloLink) {
  _inherits(PersistLink, _ApolloLink);

  _createClass(PersistLink, null, [{
    key: "shouldPersist",

    /**
     * InStorageCache shouldPersist implementation for a __persist field validation.
     */
    value: function shouldPersist(op, dataId, data) {
      // console.log(dataId, data)
      return dataId === 'ROOT_QUERY' || !data || !!data.__persist;
    }
    /**
     * InStorageCache addPersistField implementation to check for @perist directives.
     */

  }]);

  function PersistLink() {
    var _this;

    _classCallCheck(this, PersistLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PersistLink).call(this));

    _defineProperty(_assertThisInitialized(_this), "request", function (operation, forward) {
      var _extractPersistDirect = (0, _transform.extractPersistDirectivePaths)(operation.query, _this.directive),
          query = _extractPersistDirect.query,
          paths = _extractPersistDirect.paths; // Early exit if no persist directive found.


      if (!paths.length) return forward(operation); // Replace query with one without @persist directives.

      operation.query = query; // Remove requesting __persist fields.

      operation.query = (0, _graphql.visit)(operation.query, {
        Field: function Field(_ref, key, parent, path, ancestors) {
          var name = _ref.name.value;

          if (name === '__persist') {
            return null;
          }
        }
      });
      return forward(operation).map(function (result) {
        if (result.data) {
          result.data = attachPersists(paths, result.data);
        }

        return result;
      });
    });

    _this.directive = 'persist';
    return _this;
  }
  /**
   * Link query requester.
   */


  return PersistLink;
}(_apolloLink.ApolloLink);

exports.PersistLink = PersistLink;

_defineProperty(PersistLink, "addPersistField", function (doc) {
  return (0, _transform.hasPersistDirective)(doc);
});

var createPersistLink = function createPersistLink(config) {
  return new PersistLink(config);
};

exports.createPersistLink = createPersistLink;